import { DOM_IDS } from './constants.js'
import { computeBrandedHeaderTokens } from './branded-header-tokens.js'
import './branded-header.scss'
const HEADER_INNER_SELECTOR = '.frame-common-header'
const FOOTER_ROOT_SELECTOR = '.footer-copyright'
const BRANDED_HEADER_CLASS = 'is-branded-header'
const BRANDED_VARS = {
  searchSurface: '--brand-search-surface',
  textColor: '--brand-text',
  label: '--brand-label',
  divider: '--brand-divider',
  itemIdle: '--brand-item-idle',
  itemHover: '--brand-item-hover',
  itemPress: '--brand-item-press'
}
const THEME_DEFAULTS = {
  backgroundColor: '#FFFFFF',
  textColor: 'var(--zoom-color-icon-strong-neutral)'
}

function clearBrandedTokens(headerEl) {
  headerEl.classList.remove(BRANDED_HEADER_CLASS)
  Object.values(BRANDED_VARS).forEach((name) => headerEl.style.removeProperty(name))
}

function setBrandedTokens(headerEl, tokens) {
  headerEl.classList.add(BRANDED_HEADER_CLASS)
  Object.entries(BRANDED_VARS).forEach(([key, name]) => {
    headerEl.style.setProperty(name, tokens[key])
  })
}

export function applyHeaderTheme(style = {}) {
  const root = document.getElementById(DOM_IDS.HEADER_CONTAINER)
  const headerEl = root?.querySelector(HEADER_INNER_SELECTOR)
  if (!headerEl) return

  const hasCustomBackground = Boolean(style?.backgroundColor)
  headerEl.style.backgroundColor = hasCustomBackground
    ? style.backgroundColor
    : THEME_DEFAULTS.backgroundColor
  headerEl.style.color = hasCustomBackground ? style.textColor : THEME_DEFAULTS.textColor

  // Header colors come only from branded-header-color-rules.md, derived from bg and text.
  // The default header (no custom background, or non-hex colors) keeps its original styling.
  const brandedTokens = hasCustomBackground
    ? computeBrandedHeaderTokens(style.backgroundColor, style.textColor)
    : null
  const dividerTargets = [
    headerEl.querySelector('.frame-common-header__logo-text'),
    headerEl.querySelector('.new-experience-toggle')
  ].filter(Boolean)

  if (brandedTokens) {
    setBrandedTokens(headerEl, brandedTokens)
    // md section 4: divider color drives the subtle border on the logo and toggle
    dividerTargets.forEach((el) =>
      el.style.setProperty('--zoom-color-border-subtle-neutral', brandedTokens.divider)
    )
  } else {
    clearBrandedTokens(headerEl)
    dividerTargets.forEach((el) => el.style.removeProperty('--zoom-color-border-subtle-neutral'))
  }
}

// Footer divider lines (top border and legal link separators) take the md divider color.
// Set on the footer root so both inherit the same custom property.
export function applyFooterTheme(style = {}) {
  const root = document.getElementById(DOM_IDS.SIMPLIFIED_FOOTER_COPYRIGHT)
  const footerEl = root?.querySelector(FOOTER_ROOT_SELECTOR)
  if (!footerEl) return

  const tokens = computeBrandedHeaderTokens(style.backgroundColor, style.textColor)
  if (tokens) {
    footerEl.style.setProperty('--zoom-color-border-subtle-neutral', tokens.divider)
  } else {
    footerEl.style.removeProperty('--zoom-color-border-subtle-neutral')
  }
}
